import { getVocabulary } from 'components/Vocabulary';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const titleMap: Record<string, string | (() => string)> = {
  dashboard: 'Dashboard',
  insights: 'Insights',
  findings: 'Findings',
  scans: 'Scans',
  discovery: 'Discovery',
  assets: 'Assets',
  feeds: 'Feeds',
  integrations: 'Integrations',
  runbook: 'Runbooks',
  'automations/runbook': 'Runbooks',
  'automations/anya-agents': 'Anya Agents',
  reports: 'Compliance',
  assetsummary: 'Repo Summary',
  ticketListing: 'Tickets',
  'security-tools': 'Security Tools',
  scheduledReport: 'Scheduled Reports',
  compliance: 'Compliance Policies',
  log: 'Audit Logs',
  'user-management': 'User Management',
  globalsettings: 'Global Settings',
  sbom: 'Supply Chain',
  groups: () => getVocabulary('group', true),
  product: () => getVocabulary('product', true),
  subProduct: () => getVocabulary('subProduct', true),
  project: () => getVocabulary('project', true),
  exceptions: () => getVocabulary('exception', true),
  assessments: () => getVocabulary('assessment', true),
};

export const getTitle = (title: string): string => {
  const value = titleMap[title];
  if (title === 'logout' || title === 'login' || !value) return 'ArmorCode';
  const resolvedTitle = typeof value === 'function' ? value() : value;
  return `${resolvedTitle} - ArmorCode`;
};

const TitleManager: React.FC = () => {
  const location = useLocation();
  useEffect(() => {
    const segments = location.pathname.split('/').filter(Boolean).slice(3);
    // Walk from most-specific to least-specific path, returning on first titleMap match.
    // This is effectively O(1) — URL paths have at most ~4-5 segments, titleMap lookup
    // is a hash map access, and this only runs on route changes, not on every render.
    while (segments.length > 0) {
      const key = segments.join('/');
      if (titleMap[key]) {
        document.title = getTitle(key);
        return;
      }
      segments.pop();
    }
    document.title = getTitle('');
  }, [location.pathname]);

  return null;
};

export default TitleManager;
